import React from "react";
import { LOGO } from "../mock";

// A true double-sided 3D "coin" spin. Both faces show the logo the
// correct way round, so the text never appears backwards mid-flip.
const SpinningLogo = ({ size = 44, ring = "ring-[#e3efe7]" }) => {
  return (
    <span className="logo-coin inline-block" style={{ width: size, height: size }}>
      <span className={`coin ring-1 ${ring}`}>
        <span className="coin-face coin-front">
          <img src={LOGO} alt="British Supplements" />
        </span>
        <span className="coin-face coin-back">
          <img src={LOGO} alt="British Supplements" />
        </span>
      </span>
    </span>
  );
};

export default SpinningLogo;
